export type Dimension = "sm" | "md" | "lg" | "xl";

export const MEDIA_QUERIES: { [key in Dimension]: string } = {
  sm: "(max-width: 359px)",
  md: "(max-width: 767px)",
  lg: "(min-width: 1280px)",
  xl: "(min-width: 1440px)",
};
